import { render, staticRenderFns } from "./soundEffectTheme.vue?vue&type=template&id=77b5d7ef&scoped=true"
import script from "./soundEffectTheme.vue?vue&type=script&lang=ts"
export * from "./soundEffectTheme.vue?vue&type=script&lang=ts"
import style0 from "./soundEffectTheme.vue?vue&type=style&index=0&id=77b5d7ef&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b5d7ef",
  null
  
)

export default component.exports